<section class="team qize-section">
    <div class="container aos-init aos-animate" data-aos="fade-up">
        <div class="row">
            <div class="col-md-12 quiz-main-body">
                <div class="qizeheader ">
                    <div class="mobile-version">
                        <a onclick="history.back()" class="left-title mobile">
                            <i class='bx bx-left-arrow-alt'></i> TPL Quiz
                        </a>
                    </div>
                    <div class="left-title">TPL Quiz</div>
                    <div class="right-title">Total Questions: <span>{{totalRecords}}</span></div>

                </div>
                <div class="content">
                    <div class="container-fluid">

                        <div class="row">
                            <div class="col-sm-12">
                                <div *ngIf="!showResult" id="result" class="quiz-body">
                                    <!-- <form name="quizForm" onSubmit=""> -->
                                    <fieldset class="form-group">
                                        <!-- <h4><span id="qid">10</span> <span id="question"></span></h4> -->
                                        <div *ngIf="currentQuestion" class="option-block-container"
                                            id="question-options">
                                            <h4><span id="question">{{currentQuestion.question}}</span></h4>

                                            <div *ngFor="let option of currentQuestion.options"
                                                class="p-field-checkbox">
                                                <p-radioButton [inputId]="option.label" (onClick)="saveAnswer()"
                                                    name="category" [value]="option.label"
                                                    [(ngModel)]="selectedOption"></p-radioButton>
                                                <label [for]="option.label">{{option.label}}</label>
                                            </div>
                                        </div> <!-- End of option block -->
                                    </fieldset>
                                    <div class="footer-button col-md-12">
                                        <button #prevButton name="previous" id="previous" (click)="prev()"
                                            class="btn btn-border">Previous</button>
                                        &nbsp;
                                        <button *ngIf="!showSubmitButton" #nextButton name="next" id="next"
                                            (click)="next()" class="btn btn-success">Next</button>
                                        <button *ngIf="showSubmitButton" name="submit" id="submit" (click)="submit()"
                                            class="btn btn-success">Submit</button>

                                    </div>
                                    <!-- </form> -->
                                </div>
                                <div *ngIf="showResult">
                                    <div class="res-header total">
                                        <h1>Total Score: {{totalMarks}}/{{questionMarksTotal}}</h1>
                                    </div>
                                    <div *ngFor="let result of resultList">

                                        <div class="col-md-12">
                                            <div class="row">
                                                <span
                                                    class="result-question">{{result.questionanswerdata[0].question}}</span>
                                            </div>
                                            <div class="row">
                                                <span class="result-question"><b>Correct Answer</b>:
                                                    {{result.questionanswerdata[0].answer}}</span>
                                            </div>
                                            <div class="row">
                                                <span class="result-question">Score: {{result.score}}
                                                    <span *ngIf="result.score == 0">
                                                        <i class="bx bxs - x - circle"></i>
                                                    </span>
                                                    <span *ngIf="result.score != 0">
                                                        <i class="bx bxs-check-circle"></i>
                                                    </span>
                                                </span>
                                            </div>
                                            <hr>
                                        </div>



                                    </div>
                                </div>
                            </div> <!-- End of col-sm-12 -->

                        </div> <!-- End of row -->
                    </div> <!-- ENd of container fluid -->

                </div>



            </div>
        </div>
    </div>
</section>